<script setup>
  import { useWebStore } from "~/store/web";
  const store=useWebStore();
  </script>
<template>
  <div class="w-11/12 mx-auto sm:w-3/4 xl:w-3/5">
    <div class="xl:grid xl:gap-4">
      <div>
        <text-with-line-after :text="annotation" class="mb-5"/>
        <h3 class="InterExtraBold text-2xl uppercase lg:text-4xl xl:text-left">{{title}}</h3>
      </div>
      <div>
        <p class="leading-6 mt-5 text-lg lg:text-xl xl:text-justify">
          <b>{{text0 }}</b><br><br>
        </p>
      </div>
      <p class="largeText  grid-element-span2-column line-height-1_6 justified-text w100per hidden md:block" :class="store.screenSize === 'mobile'?'':''">{{text1}}</p>
    </div>
    <div id="aboutUsBanner">
      <ImageLazy
        :src="'/'+image"
        class="w-full"
        />
    </div>
  </div>
</template>
<script>
import TextWithLineAfter from "@/components/TextWithLineAfter.vue";

import ImageLazy from "./ImageLazy.vue";

export default {
  name: "TitleTextImageTemplate",
  components: {TextWithLineAfter},
  props:['title','text0','text1','annotation','image']
}
</script>

<style scoped lang="scss">
.titleTextImageTemplate{
  display: grid;
  margin: 0 auto;
  grid-template-rows: auto auto max-content;
  overflow: hidden;
  column-gap: 40px;

  #our{
    position: relative;
    width: fit-content;
    height: 2vh;
    font-family: 'Inter', sans-serif;
    color: var(--orange-color);
    &::after{
      content: "";
      position: absolute;
      right: -40%;
      height: 1.5px;
      top: 35%;
      width: 50px;
      background-color: var(--orange-color);
    }
  }
  #solutions{
    font-family: Inter-ExtraBold,sans-serif;
    font-size: var(--titleFont, 60px);
    text-transform: uppercase;
    text-align: left;
    margin: unset;
  }
  #companyInfo{
    text-align: left;
    margin-top: 10%;
    font-size: var(--largeTextFont,23px);
    span{
      font-size: var(--textFont,20px)
    }
  }
  #aboutUsBanner{
    grid-column-start: 1;
    grid-column-end: 3;
    img{
      width: 100%;
    }
  }
  &.mobile,
  &.tablet{


    width: 100%;
    grid-template-columns: 100%;
    gap: 30px;
    #leftSide,#rightSide{
      margin: 0 auto;
      padding: 20px;
      width: 85% !important;
      hyphens: auto;
    }

    #rightSide{
      width: 85%;
      #companyInfo{
        span{
          font-size: 19px;
        }
      }
    }
    #aboutUsBanner{
      grid-column: 1;
      width: 85%;
    }
  }
}
</style>